import React from 'react';
import PropTypes from 'prop-types';
import classnames from "classnames";

import Button from 'elements/stateless/button';

import './index.scss';

const Card = props => {
  const {
    title,
    logo,
    button,
    subTitle,
    children,
    footNote,
    statusIcon,
    appearance,
  } = props;

  return (
    <ul className={classnames('card-holder', `a-${appearance}`)}>
      <li className="c-head">
        {logo && (
          <div className="icon-bet" />
        )}
        {statusIcon && (
          <div className={classnames('status-icon', statusIcon)}/>
        )}
        {title && (
          <h3>{title}</h3>
        )}
        {subTitle && (
          <h4>{subTitle}</h4>
        )}
      </li>
      {children && (
        <li className="c-body">
          {children}
        </li>
      )}
      <li className="c-footer">
        {button && (
          <Button
            title={button.title}
            onClick={button.onClick}
            needsToLoad={button.needsToLoad}
            className={classnames('button', `c-${button.color}`, {
              disabled: button.disabled,
            })}
          />
        )}
        {footNote && (
          <div className="cf-note-link-holder">
            {footNote}
          </div>
        )}
      </li>
    </ul>
  )
};

Card.defaultProps = {
  logo: true,
  appearance: 'default',
};

Card.propTypes = {
  title: PropTypes.any,
  statusIcon: PropTypes.string,
  appearance: PropTypes.oneOf(['default', 'compact']),
  button: PropTypes.shape({
    title: PropTypes.any,
    onClick: PropTypes.func,
    needsToLoad: PropTypes.bool,
    disabled: PropTypes.bool,
    color: PropTypes.string,
  }),
  subTitle: PropTypes.any,
  children: PropTypes.any,
  footNote: PropTypes.any,
  logo: PropTypes.bool,
}

export default Card;
